import { defineComponent as r, openBlock as o, createBlock as m, unref as n, mergeProps as p, withCtx as h, createElementVNode as l } from "vue";
import { RevIcon as v } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconCameraWithSparkle",
  __name: "IconCameraWithSparkle",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(e) {
    const t = e;
    return (i, a) => (o(), m(n(v), p(t, { "view-box": "0 0 24 24" }), {
      default: h(() => [...a[0] || (a[0] = [
        l("path", { d: "M2.25 18.928v-9a2.25 2.25 0 0 1 2.25-2.25h2.914l.764-3.053.03-.102a1.25 1.25 0 0 1 1.183-.845h1.71a.75.75 0 0 1 0 1.5H9.585l-.625 2.5h.713a.75.75 0 0 1 0 1.5H4.5a.75.75 0 0 0-.75.75v9a.75.75 0 0 0 .75.75h15a.75.75 0 0 0 .75-.75v-5.5a.75.75 0 0 1 1.5 0v5.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25m12-4.5a2.25 2.25 0 1 0-4.5 0 2.25 2.25 0 0 0 4.5 0m2.25-3.344v-2a.75.75 0 0 1 1.5 0v2a.75.75 0 0 1-1.5 0m-1.008-4.496a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1 0-1.5h2m5.508 0a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1 0-1.5h2m-4.5-1.016v-2a.75.75 0 0 1 1.5 0v2a.75.75 0 0 1-1.5 0m-.75 8.856a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
